// Public legal pages: /legal/terms, /legal/privacy, /legal/community
import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../lib/api";

export default function Legal() {
  const { doc } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    api.get(`/legal/${doc || "terms"}`)
      .then(({ data }) => setData(data))
      .catch((e) => setErr(e?.response?.data?.detail || "Not found"));
  }, [doc]);
  if (err) return <div className="p-10 text-center text-white/60">{err}</div>;
  if (!data) return <div className="p-10 text-center text-white/40">Loading…</div>;
  return (
    <div className="max-w-3xl mx-auto p-6 lg:p-10 space-y-4" data-testid="legal-page">
      <nav className="flex gap-3 text-[10px] tracking-widest uppercase text-white/40">
        <Link to="/legal/terms"     className={doc === "terms"     ? "text-nexus-cyan" : "hover:text-white"}>Terms</Link>
        <Link to="/legal/privacy"   className={doc === "privacy"   ? "text-nexus-cyan" : "hover:text-white"}>Privacy</Link>
        <Link to="/legal/community" className={doc === "community" ? "text-nexus-cyan" : "hover:text-white"}>Community</Link>
      </nav>
      <div className="text-[10px] tracking-widest uppercase text-white/40">
        version {data.version} · effective {data.effective}
      </div>
      <div
        className="prose prose-invert max-w-none text-white/80 whitespace-pre-wrap font-mono text-sm leading-relaxed"
        data-testid="legal-body"
      >
        {data.body}
      </div>
    </div>
  );
}
